<!-- fallow-ignore-file complexity -->
<div
	#overlayRoot
	class="jepto-analysis-drawer__root"
	[class.jepto-analysis-drawer__root--contained]="
		overlayMode() === 'contained'
	"
>
	@if (isOpen()) {
		<div
			class="jepto-analysis-drawer__scrim"
			[class.jepto-analysis-drawer__scrim--contained]="
				overlayMode() === 'contained'
			"
			aria-hidden="true"
			(click)="onScrimClick()"
		></div>
	}

	<aside
		#drawerPanel
		role="dialog"
		aria-modal="true"
		[attr.data-testid]="testId() ?? null"
		[attr.aria-labelledby]="isOpen() ? 'analysis-drawer-title' : null"
		class="jepto-analysis-drawer__panel"
		[class.jepto-analysis-drawer__panel--contained]="
			overlayMode() === 'contained'
		"
		[class.jepto-analysis-drawer__panel--open]="isOpen()"
		[style.--jepto-analysis-drawer-panel-width]="panelWidth() ?? null"
		(click)="onPanelClick($event)"
	>
		<header class="jepto-analysis-drawer__header">
			<span class="jepto-analysis-drawer__badge">Analysis</span>

			@if (activePeriodTitle()) {
				<h2
					id="analysis-drawer-title"
					class="jepto-analysis-drawer__title"
				>
					{{ activePeriodTitle() }}
				</h2>
			}

			<button
				#closeBtn
				type="button"
				class="jepto-analysis-drawer__close-btn"
				aria-label="Close analysis panel"
				(click)="onCloseClick($event)"
			>
				<mat-icon class="material-symbols-outlined" aria-hidden="true"
					>close</mat-icon
				>
			</button>

			@if (analyses().length > 1) {
				<nav
					class="jepto-analysis-drawer__tabs"
					aria-label="Analysis periods"
				>
					@for (
						period of analyses();
						track periodKey(period);
						let i = $index
					) {
						<button
							type="button"
							class="jepto-analysis-drawer__tab"
							[class.jepto-analysis-drawer__tab--active]="
								isActivePeriod(period)
							"
							[attr.aria-current]="
								isActivePeriod(period) ? 'page' : null
							"
							(click)="onPeriodTabClick(periodKey(period))"
						>
							{{ periodLabel(period, i) }}
						</button>
					}
				</nav>
			}
		</header>

		<div class="jepto-analysis-drawer__body" cdkScrollable>
			@if (activePeriod()?.headline) {
				<p class="jepto-analysis-drawer__headline">
					{{ activePeriod()?.headline }}
				</p>
				<hr class="jepto-analysis-drawer__divider" />
			}
			<div #editorContainer class="jepto-analysis-drawer__editor"></div>
		</div>
	</aside>
</div>
